/* ============================================================
   RF Steps V4 - question screens
============================================================ */

const STEP_BACKGROUNDS = {
  0: 'https://cdn.shopify.com/s/files/1/0974/0212/6661/files/pem-delian-routine-finder-felkenve.jpg?v=1768469657',
  1: 'https://cdn.shopify.com/s/files/1/0974/0212/6661/files/pem-delian-routine-finder-modell.jpg?v=1768469593',
  2: 'https://cdn.shopify.com/s/files/1/0974/0212/6661/files/pem-delian-routine-finder-krem.jpg?v=1768469557',
  3: 'https://cdn.shopify.com/s/files/1/0974/0212/6661/files/pem-delian-routine-finder-szaj.jpg?v=1768469503',
  4: 'https://cdn.shopify.com/s/files/1/0974/0212/6661/files/pem-delian-routine-finder-all.jpg?v=1768469349'
};

function pemrf_v5_showError(block, message) {
  let errorDiv = block.querySelector('.pemrf-error-message-v5');
  if (!errorDiv) {
    errorDiv = pemrf_v5_createEl('div', 'pemrf-error-message-v5');
    const subtitle = block.querySelector('.pemrf-subtitle-v5');
    const title = block.querySelector('.pemrf-q-title-v5');
    const insertAfter = subtitle || title;
    if (insertAfter && insertAfter.nextSibling) {
      insertAfter.parentNode.insertBefore(errorDiv, insertAfter.nextSibling);
    } else {
      block.appendChild(errorDiv);
    }
  }
  errorDiv.textContent = message;
  errorDiv.classList.add('show');
  setTimeout(() => errorDiv.classList.remove('show'), 3000);
}

function pemrf_v5_renderQuestions() {
  const lang = pemrf_v5_getLangPack();
  const root = pemrf_v5_qs("#pemrf-questions-v5");
  const res = pemrf_v5_qs("#pemrf-result-v5");
  const news = pemrf_v5_qs("#pemrf-newsletter-step-v5");
  if (!root) return;

  if (window.innerWidth > 768) {
    const bgImage = STEP_BACKGROUNDS[window.PEMRF_V5.currentStep];
    if (bgImage) {
      root.style.backgroundImage = `url('${bgImage}')`;
    }
  } else {
    root.style.backgroundImage = 'none';
  }

  root.style.display = "flex";
  res.style.display = "none";
  if (news) news.style.display = "none";
  root.innerHTML = "";

  const steps = [
    pemrf_v5_step_age,
    pemrf_v5_step_skin_type,
    pemrf_v5_step_concerns,
    pemrf_v5_step_eye_area,
    pemrf_v5_step_cleanser
  ];

  const stepFn = steps[window.PEMRF_V5.currentStep];
  if (typeof stepFn === "function") stepFn(lang, root);
}

function pemrf_v5_step_age(lang, root) {
  const block = pemrf_v5_createEl("div", "pemrf-q-block-v5");
  const title = pemrf_v5_createEl("h2", "pemrf-q-title-v5");
  title.textContent = lang.questions.age.q;
  block.appendChild(title);

  const wrapper = pemrf_v5_createEl("div", "pemrf-answers-v5");

  Object.entries(lang.questions.age.answers).forEach(([key, label]) => {
    const row = pemrf_v5_createEl("label", "pemrf-answer-v5");
    row.innerHTML = `<span>${label}</span>`;

    row.addEventListener("click", e => {
      e.preventDefault();
      wrapper.querySelectorAll(".pemrf-answer-v5").forEach(a => a.classList.remove("selected"));
      row.classList.add("selected");
      window.PEMRF_V5.answers.age = key;
    });

    wrapper.appendChild(row);
  });

  const btnRow = pemrf_v5_createEl("div", "pemrf-button-row-v5");

  const nextBtn = pemrf_v5_createEl("button", "pemrf-next-btn-v5");
  nextBtn.textContent = lang.general.next;
  nextBtn.onclick = () => {
    if (!window.PEMRF_V5.answers.age) {
      pemrf_v5_showError(block, lang.errors.select_one);
      return;
    }
    window.PEMRF_V5.currentStep = 1;
    pemrf_v5_renderQuestions();
  };

  btnRow.appendChild(nextBtn);


  block.append(wrapper, btnRow); 
  root.appendChild(block);
}


function pemrf_v5_step_skin_type(lang, root) {
  const block = pemrf_v5_createEl("div", "pemrf-q-block-v5");
  const title = pemrf_v5_createEl("h2", "pemrf-q-title-v5");
  title.textContent = lang.questions.skin_type.q;
  block.appendChild(title);

  const wrapper = pemrf_v5_createEl("div", "pemrf-answers-v5");

  Object.entries(lang.questions.skin_type.answers).forEach(([key, label]) => {
    const row = pemrf_v5_createEl("label", "pemrf-answer-v5");
    row.innerHTML = `<span>${label}</span>`;

    row.addEventListener("click", e => {
      e.preventDefault();
      wrapper.querySelectorAll(".pemrf-answer-v5").forEach(a => a.classList.remove("selected"));
      row.classList.add("selected");
      window.PEMRF_V5.answers.skin_type = key;
    });

    wrapper.appendChild(row);
  });

  const btnRow = pemrf_v5_createEl("div", "pemrf-button-row-v5");
  
  const backBtn = pemrf_v5_createEl("button", "pemrf-back-btn-v5");
  backBtn.textContent = lang.general.back;
  backBtn.onclick = () => {
    window.PEMRF_V5.currentStep--;
    pemrf_v5_renderQuestions();
  };

  const nextBtn = pemrf_v5_createEl("button", "pemrf-next-btn-v5");
  nextBtn.textContent = lang.general.next;
  nextBtn.onclick = () => {
    if (!window.PEMRF_V5.answers.skin_type) {
      pemrf_v5_showError(block, lang.errors.select_one);
      return;
    }
    window.PEMRF_V5.currentStep = 2;
    pemrf_v5_renderQuestions();
  };

  btnRow.append(backBtn, nextBtn);
  block.append(wrapper, btnRow);
  root.appendChild(block);
}

function pemrf_v5_step_concerns(lang, root) {
  const block = pemrf_v5_createEl("div", "pemrf-q-block-v5");
  const title = pemrf_v5_createEl("h2", "pemrf-q-title-v5");
  const subtitle = pemrf_v5_createEl("div", "pemrf-subtitle-v5");

  title.textContent = lang.questions.concerns.q;
  subtitle.textContent = lang.questions.concerns.subtitle;

  block.append(title, subtitle);

  const wrapper = pemrf_v5_createEl("div", "pemrf-concerns-answers-v5");

  Object.entries(lang.questions.concerns.answers).forEach(([key, label]) => {
    const row = pemrf_v5_createEl("label", "pemrf-answer-v5");
    row.innerHTML = `<span>${label}</span>`;

    row.addEventListener("click", e => {
      e.preventDefault();

      const selected = window.PEMRF_V5.answers.concerns;

      if (selected.includes(key)) {
        window.PEMRF_V5.answers.concerns = selected.filter(x => x !== key);
        row.classList.remove("selected");
        return;
      }

      if (selected.length >= window.PEMRF_V5.maxConcerns) {
        pemrf_v5_showError(block, lang.errors.max_two);
        return;
      }

      window.PEMRF_V5.answers.concerns.push(key);
      row.classList.add("selected");
    });

    wrapper.appendChild(row);
  });

  const btnRow = pemrf_v5_createEl("div", "pemrf-button-row-v5");
  
  const backBtn = pemrf_v5_createEl("button", "pemrf-back-btn-v5");
  backBtn.textContent = lang.general.back;
  backBtn.onclick = () => {
    if (window.PEMRF_V5.currentStep > 0) {
      window.PEMRF_V5.currentStep--;
      pemrf_v5_renderQuestions();
    }
  };

  const nextBtn = pemrf_v5_createEl("button", "pemrf-next-btn-v5");
  nextBtn.textContent = lang.general.next;
  nextBtn.onclick = () => {
    if (!window.PEMRF_V5.answers.concerns.length) {
      pemrf_v5_showError(block, lang.errors.select_at_least_one); 
      return;
    }
    window.PEMRF_V5.currentStep = 3;
    pemrf_v5_renderQuestions();
  };

  btnRow.append(backBtn, nextBtn);
  block.append(wrapper, btnRow);
  root.appendChild(block);
}

function pemrf_v5_step_eye_area(lang, root) {
  const block = pemrf_v5_createEl("div", "pemrf-q-block-v5");
  const title = pemrf_v5_createEl("h2", "pemrf-q-title-v5");
  title.textContent = lang.questions.eye_area.q;
  block.appendChild(title);

  const wrapper = pemrf_v5_createEl("div", "pemrf-answers-v5");

  Object.entries(lang.questions.eye_area.answers).forEach(([key, label]) => {
    const row = pemrf_v5_createEl("label", "pemrf-answer-v5");
    row.innerHTML = `<span>${label}</span>`;

    row.addEventListener("click", e => {
      e.preventDefault();
      wrapper.querySelectorAll(".pemrf-answer-v5").forEach(a => a.classList.remove("selected"));
      row.classList.add("selected");
      window.PEMRF_V5.answers.eye_area = key;
    });

    wrapper.appendChild(row);
  });

  const btnRow = pemrf_v5_createEl("div", "pemrf-button-row-v5");
  
  const backBtn = pemrf_v5_createEl("button", "pemrf-back-btn-v5");
  backBtn.textContent = lang.general.back;
  backBtn.onclick = () => {
    window.PEMRF_V5.currentStep--;
    pemrf_v5_renderQuestions();
  };

  const nextBtn = pemrf_v5_createEl("button", "pemrf-next-btn-v5");
  nextBtn.textContent = lang.general.next;
  nextBtn.onclick = () => {
    if (!window.PEMRF_V5.answers.eye_area) {
      pemrf_v5_showError(block, lang.errors.select_one);
      return;
    }
    window.PEMRF_V5.currentStep = 4;
    pemrf_v5_renderQuestions();
  };

  btnRow.append(backBtn, nextBtn);
  block.append(wrapper, btnRow);
  root.appendChild(block);
}

function pemrf_v5_step_cleanser(lang, root) {
  const block = pemrf_v5_createEl("div", "pemrf-q-block-v5");
  const title = pemrf_v5_createEl("h2", "pemrf-q-title-v5");
  title.textContent = lang.questions.cleanser.q;
  block.appendChild(title);

  const wrapper = pemrf_v5_createEl("div", "pemrf-answers-v5");

  Object.entries(lang.questions.cleanser.answers).forEach(([key, label]) => {
    const row = pemrf_v5_createEl("label", "pemrf-answer-v5");
    row.innerHTML = `<span>${label}</span>`;

    row.addEventListener("click", e => {
      e.preventDefault();
      wrapper.querySelectorAll(".pemrf-answer-v5").forEach(a => a.classList.remove("selected"));
      row.classList.add("selected");
      window.PEMRF_V5.answers.cleanser = key;
    });

    wrapper.appendChild(row);
  });

  const btnRow = pemrf_v5_createEl("div", "pemrf-button-row-v5");
  
  const backBtn = pemrf_v5_createEl("button", "pemrf-back-btn-v5");
  backBtn.textContent = lang.general.back;
  backBtn.onclick = () => {
    window.PEMRF_V5.currentStep--;
    pemrf_v5_renderQuestions();
  };

  const nextBtn = pemrf_v5_createEl("button", "pemrf-next-btn-v5");
  nextBtn.textContent = lang.general.next;
  nextBtn.onclick = () => {
    if (!window.PEMRF_V5.answers.cleanser) {
      pemrf_v5_showError(block, lang.errors.select_one);
      return;
    }
    pemrf_v5_calculateRoutine();
  };

  btnRow.append(backBtn, nextBtn);
  block.append(wrapper, btnRow);
  root.appendChild(block);
}